import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { AreaShippingClient } from 'clients/area-shipping-client';
import { DC } from 'constants/index';
import JsonForm from 'components/dynamic-form/json-form';
import providerBuilder from '../providers/provider-builder';
import taskProviderHoc from './task-form-hoc';
import { FillDeliveryConfirmationStatus } from '../../../interfaces/enums/TaskStatuses/FillDeliveryConfirmationStatus';
import { DeliveryMethodValue } from '../../../constants/enums';

const adjustDateForHolidays = (date, holidaysSet) => {
  let adjustedDate = date.clone();

  while (
    holidaysSet.has(adjustedDate.format('YYYY-MM-DD')) ||
    adjustedDate.day() === 0 ||
    adjustedDate.day() === 6
  ) {
    adjustedDate = adjustedDate.add(1, 'days');
  }

  return adjustedDate;
};

function BundleTaskStatusForm(props) {
  const {
    data,
    formName,
    level,
    formId,
    title,
    type,
    onValidityChange,
    linkedFormIds,
    onInitialLoad,
    onFormChange,
    linkedTasks,
    additionalDocumentProps,
    drawBorder,
    taskIsSubmitting,
    dosisRegimenText,
    ...otherProps
  } = props;

  const [holidaysSet, setHolidaysSet] = useState(new Set());
  const [holidayWarning, setHolidayWarning] = useState(false);
  const [adjustedData, setAdjustedData] = useState(data);

  useEffect(() => {
    if (type === DC) {
      AreaShippingClient.fetchShippingHolidays(365).then(res => {
        const { Customer = [], Courier = [], UPS = [] } = res.data || {};
        const merged = [...Customer, ...Courier, ...UPS];
        const holidays = new Set(merged.map(d => moment.utc(d).format('YYYY-MM-DD')));
        setHolidaysSet(holidays);

        if (data.followup_dt) {
          const followupDate = moment(data.followup_dt);
          if (holidays.has(followupDate.format('YYYY-MM-DD'))) {
            const adjustedDate = adjustDateForHolidays(followupDate, holidays);
            setAdjustedData({
              ...data,
              followup_dt: adjustedDate.toDate(),
            });
          } else {
            setAdjustedData(data);
          }
        } else {
          setAdjustedData(data);
        }
      });
    } else {
      setAdjustedData(data);
    }
  }, [type, data.followup_dt]);

  const providers = providerBuilder(type)(adjustedData, props);

  if (
    adjustedData.status_id === FillDeliveryConfirmationStatus.Packed &&
    adjustedData.preferred_rx_delivery_method === DeliveryMethodValue.PickUp
  ) {
    providers.json.statuses[
      providers.json.statuses.findIndex(status => status.id === 'packed')
    ].next = 'pickup';
  }

  const handleFormChange = values => {
    if (type === DC) {
      const d = values?.followup_dt || values?.followup_date;
      if (d && holidaysSet.size) {
        const s = moment(d).format('YYYY-MM-DD');
        setHolidayWarning(holidaysSet.has(s));
      } else {
        setHolidayWarning(false);
      }
    }
    if (onFormChange) onFormChange(values);
  };

  return (
    <>
      <JsonForm
        title={title}
        jsonForm={providers.json}
        formName={formName}
        formId={formId}
        data={adjustedData}
        providers={providers}
        level={level}
        onValidityChange={onValidityChange}
        linkedFormIds={linkedFormIds}
        onInitialLoad={onInitialLoad}
        onFormChange={handleFormChange}
        linkedTasks={linkedTasks}
        forceNextStatus
        additionalDocumentProps={additionalDocumentProps}
        drawBorder={drawBorder}
        taskIsSubmitting={taskIsSubmitting}
        dosisRegimenText={dosisRegimenText}
        {...otherProps}
      />
      {holidayWarning && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: 4,
            marginBottom: 16,
          }}
        >
          <div
            style={{
              color: 'red',
              fontSize: 14,
              padding: '6px 12px',
              backgroundColor: 'rgba(255, 0, 0, 0.08)',
              borderRadius: 4,
              border: '1px solid rgba(255, 0, 0, 0.2)',
              maxWidth: 'fit-content',
            }}
          >
            ⚠️ The selected follow up date is a holiday
          </div>
        </div>
      )}
    </>
  );
}

export default taskProviderHoc(BundleTaskStatusForm);
